import React, { Component } from 'react';
import {Modal,  Input} from 'antd';

export default class Saisie extends Component {
   
    constructor(props) {
        super(props);
        this.textInput = React.createRef();
        this.state = {mot: ''};
    
    }

    handleChange = (event) => {
        this.setState({mot: event.target.value});
      }
    
    clickBouton = () =>
    {
        
        if (this.props.verifierReponse(this.state.mot.toLocaleLowerCase()))
        {
            this.setState({visible : false});
        }
        else
        {
            setTimeout(() => this.textInput.current.focus(), 0);
        }
        

    }
    modalVisible = () =>
    {
        setTimeout(() => this.textInput.current.focus(), 0);
    }
    componentDidMount() {
       this.setState({visible : true}, this.modalVisible);
      }

    annuler = () =>
    {
        this.setState({visible : false});
    }
 
    render()
    {
        return <Modal title="Votre réponse" visible={this.state.visible} onOk={this.clickBouton} onCancel={this.annuler} cancelText="Annuler">
        {this.props.definition.includes('.jpg')? <img src={process.env.REACT_APP_URL_IMAGE + '/' + this.props.definition} className="imageForm" alt=""></img>: <p className="centre">{this.props.definition}</p>}
        <div><Input type="text"  autoComplete="off" autoCorrect="off" autoCapitalize="off" 
        spellCheck="false"  value={this.state.mot} ref={this.textInput} onChange={this.handleChange} onPressEnter={this.clickBouton}></Input>
        </div>
        </Modal>
    }
}